import { Box, Paper } from '@mui/material';

import {
  FullWidthTextSkeleton,
  ProfileSkeleton,
  TextSkeleton,
} from '../../Shared/skeletons';

const CommunityMembersSkeleton = () => (
  <Paper
    elevation={0}
    sx={{
      height: '4rem',
      borderRadius: '1rem',
      marginBottom: '2rem',
    }}
  >
    <Box display="flex" gap="1rem" width="100%">
      <Box width="4rem">
        <ProfileSkeleton />
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-evenly"
        width="100%"
      >
        <TextSkeleton />
        <FullWidthTextSkeleton />
      </Box>
    </Box>
  </Paper>
);

export default CommunityMembersSkeleton;
